import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {
  private statusesWithMessages = [400, 404];
  private defaultMessage = 'Ocorreu um erro inesperado, por favor tente novamente mais tarde.';

  constructor(private toastrService: ToastrService) {}

  public getErrorMessage(error: any): string {
      let message = this.defaultMessage;

      const errorObj = error && error.error;
      const errorStatus = error && error.status;

      const errorMessage = errorObj && (errorObj.message || (errorObj[0] && errorObj[0].message));

      if (this.statusesWithMessages.includes(errorStatus) && errorMessage) {
          message = errorMessage;
      }

      if (typeof error === 'string') {
          message = error;
      }

      return message;
  }

  public displayErrorToast(error: any) {
    const message = this.getErrorMessage(error);

    if (message === this.defaultMessage) {
        this.toastrService.error(message);
    } else {
        this.toastrService.warning(message);
    }
  }


  public getErrorDetail(error: any){
    
    let message = this.defaultMessage;

    const errorObj = error && error.error;
    
    const errorMessage = errorObj && (errorObj.detail || (errorObj[0] && errorObj[0].detail));

    //console.log('erro: ', errorMessage);
    let mensagemFiltrada = errorMessage.split(':');
    //console.log('split: ', mensagemFiltrada);
    mensagemFiltrada = mensagemFiltrada[2]!=null?mensagemFiltrada[2]:errorMessage;
   
    if (typeof error === 'string') {
        message = error;
    } 

    message = mensagemFiltrada;

    return message;
 }

public isMensagemVazia(mensagem: string){

  if(mensagem == null || mensagem == ''){
    return true;
  }
  else{
    return false;
  }
}

}
